module.exports = __webpack_public_path__ + "img/74.7.Chla.792c58fb.png";